// React
import React from 'react';
// Router
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // Get auth data from localStorage
  const auth = JSON.parse(localStorage.getItem('auth'));
  const token = auth?.token;

  // If token exists allow access, otherwise redirect to login
  return token ? children : <Navigate to="/login" />;
};

export default PrivateRoute;